import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'toLocalTime' })
export class ToLocalTimePipe implements PipeTransform {
    transform(value: string | Date): string {
        return moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss');
    }
}
